import styled, { keyframes, css } from 'styled-components';

const phaseOutAnimation = keyframes`
    0% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(0.9);
    }
`;
export const StyledPageLoader = styled.div<{ $phaseOut: boolean; $phaseOutTime: number }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: radial-gradient(99.87% 99.87% at 49.11% 30.47%, rgba(15, 156, 139, 0.18) 0%, rgba(217, 217, 217, 0) 100%);
  img {
    height: 200px;
  }
  gap: 50px;

  ${({ $phaseOut, $phaseOutTime }) =>
    $phaseOut &&
    css`
      animation: ${phaseOutAnimation} ${$phaseOutTime}ms forwards;
    `}
`;
const dotAnimation = keyframes`
    0%, 20% { opacity: 0; }
    40%, 60% { opacity: 1; }
    80%, 100% { opacity: 0; }
`;
export const StyledDot = styled.div`
  display: inline-block;
  animation: ${dotAnimation} 2s infinite ease-in-out;
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
